export const ResetStep = {
  Email: 'email',
  Code: 'code',
};

export default {
  ResetStep,
};
